import {vMonthlyRetainedServiceBase} from '../database-models/v-monthly-retained-service-base';
//Generated Imports
import { actionColumn } from '@rxweb/grid';
@actionColumn({
    name: 'action',
    allowSorting: false,
    configuredTemplate: { templateName: 'action' }, columnIndex: 0, headerTitle: "Action", class: ["actionFild"],headerCellClass:["pl-4"]
})
export class vMonthlyRetainedService extends vMonthlyRetainedServiceBase 
{




//#region Generated Reference Properties

//#endregion Generated Reference Properties














































































}